module.exports = __webpack_public_path__ + "img/7.bf8a739a.jpg";